import { useEffect, useState } from "react";
import { api, fmtNum, fmtIDR } from "@/lib/api";
import { Star, ShoppingBag, MessageSquare } from "lucide-react";

export default function MarketplaceInsights() {
  const [products, setProducts] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/marketplace/products"), api.get("/marketplace/reviews")])
      .then(([p, r]) => { setProducts(p.data.data || []); setReviews(r.data.data || []); });
  }, []);

  return (
    <div className="p-6 lg:p-8 space-y-8 fade-in">
      <div className="pb-2 border-b border-[#1F1F1F]">
        <div className="label-mono">// marketplace intelligence</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2" data-testid="marketplace-title">
          Marketplace <span className="text-[#00F0FF]">Insights</span>
        </h1>
        <p className="text-zinc-500 text-sm mt-2">Produk terlaris, order, dan review pelanggan dari semua marketplace terhubung.</p>
      </div>

      {/* Top products */}
      <section>
        <h2 className="label-mono mb-3">// produk terlaris</h2>
        {products.length === 0 ? (
          <div className="border border-dashed border-[#1F1F1F] p-8 text-center label-mono text-zinc-500">tidak ada marketplace aktif</div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {products.map((mp) => (
              <div key={mp.type} className="border border-[#1F1F1F] bg-[#0A0A0A]" data-testid={`marketplace-products-${mp.type}`}>
                <div className="px-4 py-3 border-b border-[#1F1F1F] flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <ShoppingBag size={14} className="text-[#00E676]" />
                    <span className="font-medium text-sm">{mp.channel}</span>
                  </div>
                  <span className="label-mono">top 5</span>
                </div>
                <table className="w-full">
                  <tbody>
                    {mp.products.map((p, i) => (
                      <tr key={i} className="border-b border-[#1F1F1F] last:border-0">
                        <td className="px-4 py-3 text-sm">
                          <div className="flex items-center gap-3">
                            <span className="font-mono text-xs text-zinc-600 w-4">{String(i+1).padStart(2,"0")}</span>
                            <span>{p.name}</span>
                          </div>
                        </td>
                        <td className="px-3 py-3 text-right font-mono text-xs text-zinc-400">{fmtNum(p.sold)} sold</td>
                        <td className="px-3 py-3 text-right font-mono text-xs text-[#00E676]">{fmtIDR(p.revenue)}</td>
                        <td className="px-3 py-3 text-right font-mono text-xs text-[#FFCC00]">★{p.rating}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Reviews */}
      <section>
        <h2 className="label-mono mb-3">// review terkini</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {reviews.map((mp) => (
            <div key={mp.type} className="border border-[#1F1F1F] bg-[#0A0A0A]" data-testid={`marketplace-reviews-${mp.type}`}>
              <div className="px-4 py-3 border-b border-[#1F1F1F] flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <MessageSquare size={14} className="text-[#00F0FF]" />
                  <span className="font-medium text-sm">{mp.channel}</span>
                </div>
                <span className="label-mono text-[#FFCC00]">★ {mp.rating}</span>
              </div>
              <div className="divide-y divide-[#1F1F1F]">
                {mp.reviews.slice(0, 4).map((r, i) => (
                  <div key={i} className="px-4 py-3">
                    <div className="flex items-center justify-between mb-1">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium">{r.author}</span>
                        <span className={`label-mono ${r.rating >= 4 ? "text-[#00E676]" : r.rating >= 3 ? "text-[#FFCC00]" : "text-[#FF3B30]"}`}>
                          {"★".repeat(r.rating)}{"☆".repeat(5-r.rating)}
                        </span>
                      </div>
                      <span className="label-mono">{r.date}</span>
                    </div>
                    <p className="text-sm text-zinc-400">{r.text}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
